// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import i18next from 'i18next';

export default function getColumnHeaders(t: i18next.TFunction): any {
    return [
        {
            fieldName: 'firstName',
            name: t('first_name'),
            maxWidth: 160,
            minWidth: 100,
            width: 160,
            visible: true,
        },
        {
            fieldName: 'lastName',
            name: t('last_name'),
            maxWidth: 160,
            minWidth: 100,
            width: 160,
            visible: true,
        },
        {
            fieldName: 'email',
            name: t('email'),
            maxWidth: 200,
            minWidth: 200,
            width: 200,
            visible: true,
        },
        {
            fieldName: 'roleName',
            name: t('role'),
            maxWidth: 100,
            minWidth: 100,
            width: 100,
            visible: true,
        },
        {
            fieldName: 'tierName',
            name: t('tier_name'),
            maxWidth: 20,
            minWidth: 20,
            width: 80,
            visible: true,
        },
        {
            fieldName: 'soldtoCustomerName',
            name: t('sold_to'),
            maxWidth: 250,
            minWidth: 200,
            visible: false,
        },
        {
            fieldName: 'shiptoCustomerName',
            name: t('ship_to'),
            maxWidth: 250,
            minWidth: 200,
            visible: false,
        },
        {
            fieldName: 'actions',
            name: t('actions'),
            maxWidth: 70,
            minWidth: 70,
            width: 100,
            visible: true,
        },
        {
            fieldName: 'isActive',
            name: t('user_status'),
            maxWidth: 110,
            minWidth: 110,
            width: 100,
            visible: true,
        },
        {
            fieldName: 'userStatus',
            name: t('status'),
            maxWidth: 110,
            minWidth: 110,
            visible: false,
        },
    ];
}